import React from 'react';
import { useAppContext } from '../contexts/AppContext.tsx';
import WebhookSettings from '../components/WebhookSettings.tsx';

const SettingsPage: React.FC = () => {
  const { isLoading } = useAppContext();

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <div className="text-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500 mx-auto"></div>
          <p className="mt-4 text-gray-600">데이터를 불러오는 중...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-2xl font-semibold text-gray-800">설정</h1>
      </div>
      
      {/* 시스템 정보 */}
      <div className="bg-white p-4 rounded-lg shadow-sm mb-6">
        <h2 className="text-lg font-medium text-gray-700 mb-4">시스템 정보</h2>
        <div className="space-y-2">
          <div className="flex justify-between border-b border-gray-200 pb-2">
            <span className="text-sm text-gray-700">앱 버전</span>
            <span className="text-sm text-gray-900">1.1.0</span>
          </div>
          <div className="flex justify-between border-b border-gray-200 pb-2">
            <span className="text-sm text-gray-700">데이터베이스</span>
            <span className="text-sm text-gray-900">Firebase Firestore</span>
          </div>
          <div className="flex justify-between border-b border-gray-200 pb-2">
            <span className="text-sm text-gray-700">저장 상태</span>
            <span className="text-sm text-green-600">연결됨</span>
          </div>
          <div className="flex justify-between">
            <span className="text-sm text-gray-700">마지막 업데이트</span>
            <span className="text-sm text-gray-900">{new Date().toLocaleDateString()}</span>
          </div>
        </div>
      </div>

      {/* 웹훅 설정 */}
      <WebhookSettings />
    </div>
  );
};

export default SettingsPage; 